<template>
	<div class="main-content-padding">
		<Panel :contentPaddingTop="12" class="view-rules">
			<platformTab @change="handleClick" :showAll="false" :platformId="platformId" />
			<div v-show="showPlatformContent">
				<template v-if="loadingStatus === 'loading'">
					<div class="loading" v-loading="loading"></div>
				</template>
				<template v-else-if="loadingStatus === 'never'">
					<div class="align-center pl-24 pr-24 mt-20">
						<img src="@/assets/public/collaborate-rules-introduce.png" alt="" />
					</div>
					<div class="align-center" style="margin-top: 26px" v-if="$auth.hasPermi('system:editRules-query')">
						<el-button :disabled="$isSp()" type="primary" @click="editRules">前往设置规则</el-button>
					</div>
				</template>
				<template v-if="loadingStatus === 'exist'">
					<div>
						<span class="yx-color-text-primary mr-24 font-bold">全局协作规则</span>
						<el-switch v-model="rules.ruleStatus" @change="changeSwitch" inactive-color="#E2E3E8" :active-value="1" :inactive-value="0"></el-switch>
					</div>
					<div class="mt-16" v-if="$auth.hasPermi('system:editRules-query')">
						<el-button type="primary" @click="editRules">修改规则</el-button>
					</div>
					<ruleItem>
						<div slot="title" class="flex-row-align-center">
							<i class="i-coll-rule1"></i>
							<span class="font-h4-medium ml-6 mr-4">自动同步协作申请</span>
						</div>
						<div class="ruleList_item_content">
							<div class="font-h4-regular mb-8">{{ collaborateText }}</div>
						</div>
						<p slot="ruleText">开关开启后系统将每1分钟1次自动将符合规则的样品订单发起协作申请；</p>
					</ruleItem>
					<ruleItem :showExplain="false">
						<div slot="title" class="flex-row-align-center">
							<i class="i-coll-rule1"></i>
							<span class="font-h4-medium ml-6 mr-4">协作申请可展示达人信息(昵称/头像默认展示)</span>
						</div>
						<div class="ruleList_item_content">
							<div class="font-h4-regular mb-8">{{ collaborateText2 }}</div>
						</div>
					</ruleItem>
					<ruleItem>
						<div slot="title" class="flex-row-align-center">
							<i class="i-coll-rule3"></i>
							<span class="font-h4-medium ml-6 mr-4">允许手动同步样品交付视频给商家</span>
						</div>
						<div class="ruleList_item_content">
							<div class="font-h4-regular mb-8">{{ collaborateText3 }}</div>
						</div>
						<p slot="ruleText">开关开启后招商可在【合作进度-开播表】手动将合作进度关联的交付视频同步给商家；</p>
					</ruleItem>
					<template v-if="!rules.ruleStatus">
						<Tip type="warning">全局协作规则已关闭，单店规则同步失效</Tip>
						<div class="cut-line"></div>
					</template>
					<div class="pt-24">
						<div>
							<span class="yx-color-text-primary font-h3-medium">单店协作规则</span>
							<span class="ml-4 yx-color-text-secondary font-h6-regular">
								添加的店铺可对该店铺做单独规则设置；店铺优先取单店协作规则，其次全局协作规则
							</span>
						</div>
						<div class="mt-16 pos-rela">
							<div>
								<p>
									<el-button type="primary" @click="$refs.addShopDrawer.show()">添加店铺</el-button>
									<span class="ml-16 font-h6-regular yx-color-text-regular">
										已添加
										<span class="yx-color-primary font-bold">{{ total }}</span>
										间店铺
									</span>
								</p>
								<multi-table :page="pageInfo" :columns="columns" @gePartnerList="pagerList" :list="shopList" :total="total"></multi-table>
							</div>
							<div class="pos-abso mask" v-if="!rules.ruleStatus"></div>
						</div>
					</div>
				</template>
			</div>

			<!-- 添加店铺 -->
			<add-shop-drawer ref="addShopDrawer" @refresh="getShopList" :platformId="platformId" />

			<!-- 关闭规则 -->
			<confirm-close-dialog ref="confirmCloseDialog" :platformId="platformId" @closeRules="closeRules" />

			<!-- 删除店铺 -->
			<del-shop-dialog ref="delShopDialog" :platformId="platformId" @refresh="getShopList" />
		</Panel>
	</div>
</template>
<script>
import { mapGetters } from 'vuex';
import ruleItem from '@/components/business/ruleItem';
import shopTable from './components/shopTable.vue';
import addShopDrawer from './components/addShopDrawer.vue';
import { institutionGetRule, institutionCloseRule, institutionGetShopList } from '@/api/cooperativeShop';
import confirmCloseDialog from './components/confirmCloseDialog.vue';
import { platformMixin } from '@rd/rd-ui';
import getColums from './columns';
import delShopDialog from './components/delShopDialog.vue';
export default {
	components: {
		ruleItem,
		shopTable,
		addShopDrawer,
		confirmCloseDialog,
		delShopDialog,
	},
	mixins: [platformMixin],
	computed: {
		...mapGetters(['defaultPlatform']),
		collaborateText({ rules }) {
			const desc1 = {
				0: '不允许',
				1: '允许',
			};
			const desc2 = {
				1: '且样品协作内容(审核+发货)',
				2: '且样品协作内容(发货)',
			};
			return `${desc1[rules.contentStatus]}${rules.contentStatus ? desc2[rules.contentType] : ''}`;
		},
		collaborateText2({ rules }) {
			const arr = [
				{ label: '达人抖快号', key: 'anchor_account' },
				{ label: '带货等级', key: 'anchor_level' },
				{ label: '粉丝量', key: 'fans_num' },
				{ label: '场均销售额', key: 'live_sale' },
				{ label: '单视频销售额', key: 'video_sale' },
				{ label: '30日销售额', key: 'fee_30' },
			];
			let textList = [];
			rules.dataAuthority.forEach(item => {
				textList.push(arr.find(v => v.key === item).label);
			});
			return textList.join('、');
		},
		collaborateText3({ rules }) {
			const desc1 = {
				0: '不允许',
				1: '允许',
			};
			return desc1[rules.isSyncVideo];
		},
	},
	data() {
		return {
			platformId: '',
			isOpen: '1',
			loadingStatus: 'loading',
			loading: false,
			shopLoading: false,
			rules: {},
			total: 0,
			pageInfo: {
				page_index: 1,
				page_size: 10,
			},
			shopList: [],
			columns: getColums(this),
		};
	},
	created() {
		this.getRules();
		this.getShopList();
	},
	methods: {
		async getRules() {
			const { platformId } = this;
			this.loading = true;
			try {
				const data = await institutionGetRule({ platformId, shopId: 0 });
				this.rules = data;
				this.loadingStatus = data.isSet ? 'exist' : 'never';
			} catch {
				this.loading = false;
				this.loadingStatus = 'exist';
			}
		},
		async getShopList() {
			this.shopLoading = true;
			const { platformId, pageInfo } = this;
			try {
				const { list = [], page = {} } = await institutionGetShopList({ platformId, ...pageInfo });
				this.shopList = list.map(item => ({
					...item,
					operations: this.getButtons(item),
				}));
				this.total = `${page.item_total}`;
			} finally {
				this.shopLoading = false;
			}
		},
		// 每页展示条数变化
		sizeChange(val) {
			this.pageInfo.page_size = val;
			this.getShopList();
		},
		// 页数变化
		currentChange(val) {
			this.pageInfo.page_index = val;
			this.getShopList();
		},
		changeSwitch(val) {
			if (val) {
				this.closeRules(val);
			} else {
				this.rules.ruleStatus = 1;
				this.$refs.confirmCloseDialog.show();
			}
		},
		async closeRules(status) {
			const { platformId } = this;
			await institutionCloseRule({ platformId, status });
			if (!status) this.rules.ruleStatus = 0;
			this.$message.success('操作成功！');
			this.getRules();
		},
		editRules() {
			this.$router.push('/cooperativeShop/collaborateRules/editRules?platform_id=' + this.platformId);
		},
		handleClick(val) {
			this.platformId = val;
			if (!this.showPlatformContent) return;
			this.getRules();
			this.getShopList();
		},
		getButtons() {
			const arr = [];
			arr.push({
				label: '移除',
				type: 'text',
				classtype: 2,
				isShow: true,
				click: row => this.$refs.delShopDialog.show(row.outerShopId),
			});
			return arr;
		},
		pagerList(obj) {
			const { page_index, page_size } = obj;
			this.pageInfo.page_index = page_index;
			this.pageInfo.page_size = page_size;
			this.getShopList();
		},
	},
};
</script>
<style lang="less" scoped>
.loading {
	width: 100%;
	height: calc(100vh - 140px);
}
.cut-line {
	background-color: @color-gy2;
	height: 16px;
}
.mask {
	width: 100%;
	height: 100%;
	background-color: #fff;
	top: 0;
	left: 0;
	opacity: 0.6;
}
</style>
